<template>
	<div class="master-head master-head-buttons">
		<ul class="button-ul">
			<li class="master-head-list">
				<div class="button-img">
					<button
						class="vs-component vs-button button button-xl vs-button-primary vs-button-border"
						@click="clickHandle"
					>
						<span class="vs-button-text vs-button--text">Update</span>
						<i class="reload"></i>
					</button>
				</div>
			</li>
		</ul>
		<ul class="button-ul drop-options">
			<li class="master-head-list" @click.stop="masterHeadListClick">
				<p class="vs-con-dropdown b-dropdown-arrow" ref="masterHeadLink">
					{{currentReport}}
					<i class="list-down-arrow arrow-down"></i>
				</p>
				<div class="report-header-options" ref="masterHeadListBtn">
					<ul>
						<router-link :to="{name:'bench-overview'}" tag="li">
							<span>Bench Overview</span>
						</router-link>
						<router-link :to="{name:'customer-engagement'}" tag="li">
							<span>Customer Engagement</span>
						</router-link>
						<router-link :to="{name:'customer-turnover'}" tag="li">
							<span>Customer Turnover</span>
						</router-link>
						<router-link :to="{name:'consultant-workload'}" tag="li">
							<span>Consultant Workload</span>
						</router-link>
						<router-link :to="{name:'qcentris-unit-turnover'}" tag="li">
							<span>Qestit Unit Turnover</span>
						</router-link>
						<router-link :to="{name:'qcentris-country-turnover'}" tag="li">
							<span>Qestit Country Turnover</span>
						</router-link>
					</ul>
				</div>
			</li>
		</ul>
		<i class="csv-export button-export button-export-common" @click.stop="exportExcel()"></i>
	</div>
</template>

<script>
    export default {
        name: "ReportHeader",
        computed: {
            /**
             * Get the current report title from the current route
             */
            currentReport: function () {
                switch (this.$route.name) {
                    case "bench-overview":
                        return "Bench Overview";
                    case "customer-engagement":
                        return "Customer Engagement";
                    case "customer-turnover":
                        return "Customer Turnover";
                    case "consultant-workload":
                        return "Consultant Workload";
                    case "qcentris-unit-turnover":
                        return "Qcentris Unit Turnover";
                    case "qcentris-country-turnover":
                        return "Qcentris Country Turnover";
                    default:
                        return "";
                }
            }
        },
        methods: {
            /**
             * Click event handle for the dropdown
             * @param event
             */
            masterHeadListClick: function (event) {
                
                //Close main header style.
                setTimeout(function(){
                if(document.querySelector('.report-subheader-nav') != undefined && document.querySelector('.report-subheader-nav') != null){
                    document.querySelector('.report-subheader-nav').classList.remove('open-report-nav');
                }
                }, 100)
                
                
                if (
                    document.querySelector(".menu-dropdown.open-d") != undefined &&
                    document.querySelector(".menu-dropdown.open-d") != null
                ) {
                    document
                        .querySelector(".menu-dropdown.open-d")
                        .classList.remove("open-d");
                }

                if (
                    event.srcElement.nextElementSibling &&
                    event.srcElement.nextElementSibling.classList &&
                    event.srcElement.nextElementSibling.classList.contains("r-open")
                ) {
                    this.$refs.masterHeadListBtn.classList.remove("r-open");
                } else {
                    if (
                        this.$refs.masterHeadListBtn &&
                        this.$refs.masterHeadListBtn.classList
                    ) {
                        this.$refs.masterHeadListBtn.classList.add("r-open");
                    }
                }
            },
            /**
             * Handle click on the update button
             * Emit event
             */
            clickHandle: function () {
                this.$emit("updateEvent");
            },
            exportExcel: function () {
                this.$emit("downloadEvent");
            }
        },
        mounted() {
            document.body.addEventListener("click", e => {
                if (
                    e.srcElement !== this.$refs.masterHeadListBtn &&
                    this.$refs.masterHeadListBtn &&
                    this.$refs.masterHeadListBtn.classList
                ) {
                    this.$refs.masterHeadListBtn.classList.remove("r-open");
                }
                
                // Click event
                if(!e.srcElement.closest('.master-head-list')){
                    document.querySelector('.report-header-options').classList.remove('r-open');
                }
            });
            
            document.body.addEventListener('touchstart', (e)=>{
                // Click event
                if(!e.srcElement.closest('.master-head-list')){
                    document.querySelector('.report-header-options').classList.remove('r-open');
                }
            })
        }
    };
</script>

<style scoped>
	/* Report header dropdown styles */
	.master-head-list {
		position: relative;
	}

	.report-header-options {
		position: absolute;
		top: 30px;
		left: 0;
		height: auto;
		max-height: 0;
		width: 220px;
		background: #ffffff;
		z-index: 997;
		box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-moz-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		-webkit-box-shadow: 1px 7px 10px 0px rgba(0, 0, 0, 0.14);
		overflow: hidden;
	}

	.report-header-options.r-open {
		max-height: 400px;
		padding-top: 10px;
		padding-bottom: 10px;
	}

	.report-header-options li {
		padding: 14px 20px;
		cursor: pointer;
	}

	.router-link-active span {
		position: relative;
	}

	.router-link-active span:after {
		content: "";
		width: 100%;
		height: 1px;
		background: #a0a0a0;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	/* Common export button */
	.button-export-common {
		position: absolute;
		right: 12px;
		top: 50%;
		transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
		-moz-transform: translateY(-50%);
		margin-top: -2px;
	}

	.master-head {
		position: relative;
	}

	@media screen and (max-width: 1200px) {
		.master-head master-head-buttons {
			min-width: 370px;
		}
	}
</style>
